import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  Field,
  FormComponent,
  FormReturnType,
  NaturalFormConfig,
  NaturalFormFlavour,
  NaturalFormStyle,
  Section,
} from "@cotecna/dynamic-view-engine";

@Component({
    selector: "im-add-form-dialog",
    templateUrl: "./add-form-dialog.component.html",
    styleUrls: ["./add-form-dialog.component.scss"],
    standalone: false
})
export class AddFormDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @ViewChild("naturalForm")
  form: FormComponent;

  public sections: Section[] = [];
  public controls: any[];
  public naturalFormConfig: NaturalFormConfig = <NaturalFormConfig>{
    displayMode: NaturalFormStyle.transparent,
    flavor: NaturalFormFlavour.informative,
    notifyFieldChange: true,
    returnType: FormReturnType.entity,
  };
  public value: any;

  ngOnInit(): void {
    this.sections = JSON.parse(JSON.stringify(this.data.sections));
    this.controls = JSON.parse(JSON.stringify(this.data.controls));
  }

  ngAfterViewInit(): void {
    if (this.form.fieldChange) {
      this.form.fieldChange.subscribe((field: Field) => {
        this.value = field.value;
      });
    }
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public save() {
    this.dialogRef.close({
      data: this.value,
    });
  }
}
